import { createContext } from "react";
import { IMillNetworkDetailsContext, RangeHours } from "./MillNetworkDetailsContextInterfaces";

export const initialState: IMillNetworkDetailsContext = {
    rangeFilterOptions: [],
    rangeSelected: RangeHours["24_HOURS"].value,
    handleRangeSelection: () => {},
    statusAverages: null,
    statusReports: [],
    loading: true,
    refetch: async () => {},
    statusReportsTableResources: {
        handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => {},
        handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => {},
        handleChangePage: (event: unknown, newPage: number) => {},
        order: "asc",
        orderBy: "",
        page: 0,
        rowsPerPage: 25,
    },
};

export const MillNetworkDetailsContext = createContext(initialState);
